export const migrations = {
  1: (state) => {
    return {
      ...state,
      prefs: {
        ...state.prefs,
        smallDecimals: true,
      },
    };
  },
  2: (state) => {
    return {
      ...state,
      prefs: {
        ...state.prefs,
        windDirectionConvention: 'oceanographic',
      },
    };
  },
  3: (state) => {
    const {stationDetailList, ...weather} = state.weather;
    return {...state, weather};
  },
};
